import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Table from "../../components/datatable/datatable";
import SearchComponent from "../../components/search";
import { fetchDashboardData, adminFetchAllApplications } from "../../core/axios/endpoints";
import { RoutesFullPath } from "../../utils/constants";

const AdminDashboardPage = (props) => {
  const [data, setData] = useState({ data: [], totalDataCount: 0 });
  const [dashboardData, setDashboardData] = useState({
    totalApplications: 0,
    applicationCounts: {
      eia: 0,
      eiaZon: 0,
      isde: 0,
    },
    totalPaidInvoices: 0,
    latestApplications: [],
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const formatNumber = (number) => {
    return number.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };


  const columns = [
    {
      title: "Naam",
      dataIndex: "naam",
      render: (text, record) => <span>{record?.klantId?.naam}</span>
    },
    {
      title: "Regeling",
      dataIndex: "regling",
      sorter: (a, b) => a.regling.localeCompare(b.regling),
    },
    {
      title: "Datum",
      dataIndex: "createdAt",
      render: (text) => <span>{new Date(text).toLocaleDateString()}</span>,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Bedrag",
      dataIndex: "totaal",
      render: (text) => <span>€{formatNumber(text || '0')}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  const fetchData = async ({ page, pageSize, resetPageSize }) => {
    setLoading(true);
    try {
      const reglings = ["EIA", "EIA Zon", "ISDE"];
      const limitPerRegling = page * pageSize;
      const responses = await Promise.all(
        reglings.map((regling) =>
          adminFetchAllApplications(1, limitPerRegling, "", regling, "new")
        )
      );

      const merged = responses
        .flatMap((r) => r.docs || [])
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      const start = (page - 1) * pageSize;
      const end = start + pageSize;
      const paged = merged.slice(start, end).map((item, index) => ({ ...item, key: start + index }));

      const totalDataCount = responses.reduce((sum, r) => sum + (r.totalDocs || 0), 0);

      const result = {
        data: paged,
        totalDataCount,
        resetPageSize,
      };
      setData(result);
    } catch (error) {
      console.error("Error fetching applications for dashboard:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCardsData = async () => {
    try {
      const response = await fetchDashboardData();
      setDashboardData(response);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleViewClick = (record) => {
    navigate(`${RoutesFullPath.aanvraagDetailsEIAAdmin}/${record?._id}`, {
        state: {admin:true}
    });
  };



  useEffect(() => {
    fetchCardsData();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content admin-pages">
        <div className="py-4 mb-2">
          <div className="grid md:grid-cols-5 grid-cols-1 mt-5 md:gap-[30px]">
            <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
              <p className="title text-[15px]">Totaal Aanvragen</p>
              <div className="text-with-icon flex items-center gap-2 mt-3">
                <div className="icon bg-[#E4F0FF]">
                  <FeatherIcon icon="user" size="20" />
                </div>
                <p className="count text-[16px]">{dashboardData.totalApplications}</p>
              </div>
            </div>

            <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
              <p className="title text-[15px]">EIA Aanvragen</p>
              <div className="text-with-icon flex items-center gap-2 mt-3">
                <div className="icon bg-[#E4F0FF]">
                  <FeatherIcon icon="user" size="20" />
                </div>
                <p className="count text-[16px]">{dashboardData.applicationCounts.eia}</p>
              </div>
            </div>

            <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
              <p className="title text-[15px]">EIA Zon Aanvragen</p>
              <div className="text-with-icon flex items-center gap-2 mt-3">
                <div className="icon bg-[#E4F0FF]">
                  <FeatherIcon icon="user" size="20" />
                </div>
                <p className="count text-[16px]">{dashboardData.applicationCounts.eiaZon}</p>
              </div>
            </div>

            <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
              <p className="title text-[15px]">ISDE Aanvragen</p>
              <div className="text-with-icon flex items-center gap-2 mt-3">
                <div className="icon bg-[#E4F0FF]">
                  <FeatherIcon icon="user" size="20" />
                </div>
                <p className="count text-[16px]">{dashboardData.applicationCounts.isde}</p>
              </div>
            </div>

            <div className="card card-type-2 bg-[#F9F9F9] px-10 py-6 rounded-[20px]">
              <p className="title text-[15px]">Betaalde Facturen</p>
              <div className="text-with-icon flex items-center gap-2 mt-3">
                <div className="icon financieel">
                  <span>€</span>
                </div>
                <p className="count text-[16px]">{formatNumber(dashboardData.totalPaidInvoices || '0')}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive card p-4 bg-[#FAFBFE]">
          <div className="bg-[#FAFBFE] p-4 text-[20px]">
            <strong className="font-semibold">Recente Aanvragen</strong>
          </div>
          <div className="bg-white rounded-[20px]">
              <Table
                columns={columns}
                response={data}
                fetchData={fetchData}
                onRowClick={handleViewClick}
                loading={loading}
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;
